const errorMessages: Record<string, string> = {
	INTERNAL_SERVER_ERROR: 'Something went wrong - Please try again.',
	STATUS_404: 'It looks like something went wrong. Try again after sometime.',
	STATUS_400: 'Please check the inputs you have provided.',
	PR002:
		'You do not have the required permission to perform this function. Please contact helpdesk or your account manager.',
	PR004: 'Unauthorized',
	INVALID_USER_ID:
		'It looks like something went wrong. Try again after sometime.',
	INVALID_MERCHANT_ID:
		'It looks like something went wrong. Try again after sometime.',
	INVALID_TOKEN:
		'It looks like something went wrong. Try again after sometime.',
	REPORT_NOT_FOUND:
		'Report is not generated yet. Please check after some time.',
	MIGS_KILL_SWITCH_ENGAGED:
		"We're unable to process this request due to a technical issue. Please try later.",
	USER_NOT_ACTIVE: '',
	INVALID_LOGIN: 'Please check username and password.',
	USER_NOT_FOUND: '',
	USER_NOT_REGISTERED: '',
	PASSWORD_NOT_YET_SET: '',
	USER_BANNED: '',
	OTP_EXPIRED: 'OTP expired. Please request for another OTP.',
	UNABLE_TO_SEND_OTP: 'Please try sending OTP again.',
	INVALID_OTP: 'OTP is invalid. Please request for a new OTP.',
	INVALID_CREDENTIAL: 'Please check the credentials and try again',
	ATTEMPTS_EXHAUSTED: '',
	CF002: 'Something went wrong! Please try again.',
	CF004: 'Something went wrong! Please try again.',
	CF005: 'Something went wrong! Please try again.',
	CF006: 'Something went wrong! Please try again.',
	CF007: 'Something went wrong! Please try again.',
	ECONNABORTED: 'Request timed out, Please try again',
	AUTHORIZATION_FAILED: 'Authorization failed, Please login to continue.',
	FORBIDDEN: 'Something went wrong - Please try again',
	BAD_REQUEST: '',
	REFUND_NOT_ALLOWED:
		'Refund permission is denied. Please contact Merchant helpdesk or your account manager.',
	MERCHANTID_MISMATCH: '',
	MERCHANT_ID_STORE_ID_MISMATCH: '',
	MERCHANT_ID_VALIDATION_FAILED: '',
	DOCSTORE_ERROR: 'Something went wrong, Please try again.',
	TOKEN_EXPIRED: '',
	INVALID_FILE: 'Please check the file format.',
	BATCH_PROCESSING_ERROR:
		'There is some error in processing your file, Please retry.',
	FILE_LIMIT_EXCEED:
		'Your uploaded file has exceeded size limit. Maximum supported file size is 50Mb.',
	DOCUMENT_EXPIRED:
		'Please regenerate the report as the older version of report has been removed.',
	COMMUNICATION_ERROR: 'Something went wrong - Please try again',
	USER_ALREADY_EXISTS:
		'User already exists. if user has not accepted invite yet, please delete the previous invitation and add them again.',
	NOTIFICATION_RECEIVER_EXIST:
		'This receiver is already registered for notifications, please try with a different receiver',
	USER_ACCESS_LIMIT_REACHED:
		'User store access limit is reached. No more stores can be added.',
	STATUS_529: 'This feature is disabled.Please contact Merchant Helpdesk',
	RECENT_SETTLEMENT_API_GENERIC_ERROR:
		'Something went wrong. Please try again.',
	REPORT_GENERATION_ERROR:
		'Something went wrong. Please try generating settlement report again.',
	VENDOR_EDD_SUBMITTED:
		"Your  account verification is currently in progress. Our team is reviewing your submitted information. This process typically takes 1-2 business days. We'll notify you once verification is complete.",
	VENDOR_EDD_COMPLETED: 'Your video kyc verification is already completed',
	LINK_META_AND_PHONE_NUMBER_MISMATCH:
		'Something went wrong! Please check the number and try again',
	LINK_META_NOT_FOUND:
		'Something went wrong! Please check the url and try again',
};

function getErrorMessage(code: number | string, type = 'API_ERROR') {
	if (type === 'API_ERROR') {
		return errorMessages[code];
	}

	return errorMessages[`STATUS_${code}`];
}

export default getErrorMessage;
